import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { BariPreSecretarialAssistantMedScreeningReportBaseData } from './bariPreSecretarialAssistantMedScreeningReportData';

export type BariPreSecretarialAssistantMedScreeningReportBaseReadKey =
    | keyof BariPreSecretarialAssistantMedScreeningReportBaseData
    | 'gewicht_lengte_bmi';

export type BariPreSecretarialAssistantMedScreeningReportBaseReadLabel =
    | 'Aantal eenheden'
    | 'Alcohol'
    | 'Bloeddruk diastolisch'
    | 'Bloeddruk gemeten'
    | 'Bloeddruk systolisch'
    | 'BMI'
    | 'Buikomvang'
    | 'Datum screening'
    | 'Drugs'
    | 'Gewicht / Lengte / BMI'
    | 'Hoogste lichaamsgewicht'
    | 'Pols'
    | 'Saturatie'
    | 'Toelichting alcohol'
    | 'Toelichting drugs';

export type BariPreSecretarialAssistantMedScreeningReportReadSectionTitle = 'Biometrische gegevens' | 'Intoxicaties';

export const biometrischeGegevensReadSection: TypedReadSchema<
    BariPreSecretarialAssistantMedScreeningReportBaseReadKey,
    BariPreSecretarialAssistantMedScreeningReportBaseReadLabel,
    BariPreSecretarialAssistantMedScreeningReportReadSectionTitle
> = {
    items: [
        { key: 'datum_screening', label: 'Datum screening', type: 'dateAsString' },
        { key: 'gewicht_lengte_bmi', label: 'Gewicht / Lengte / BMI' },
        { append: 'kg', key: 'hoogste_gewicht_in_kg', label: 'Hoogste lichaamsgewicht', type: 'number' },
        { append: 'cm', key: 'buikomvang', label: 'Buikomvang', type: 'number' },
        { key: 'bloeddruk_gemeten', label: 'Bloeddruk gemeten', type: 'boolean' },
        { append: 'mmHg', key: 'bloeddruk_diastolisch', label: 'Bloeddruk diastolisch', type: 'number' },
        { append: 'mmHg', key: 'bloeddruk_systolisch', label: 'Bloeddruk systolisch', type: 'number' },
        { append: '/min', key: 'pols', label: 'Pols', type: 'number' },
        { append: '%', key: 'saturatie', label: 'Saturatie', type: 'number' },
    ],
    sectionTitle: 'Biometrische gegevens',
};
